import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=1060a5cd&"
import script from "./DesktopHeader.vue?vue&type=script&lang=js&"
export * from "./DesktopHeader.vue?vue&type=script&lang=js&"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports